// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Link from 'components/Link';
import Image from 'components/Image';

// local
import styles from './ProjectPreview.pcss';


export default class ProjectPreview extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    company: PropTypes.shape({
      name: PropTypes.string,
    }),
    project: PropTypes.shape({
      company: PropTypes.string,
      images: PropTypes.arrayOf(PropTypes.string).isRequired,
      name: PropTypes.string,
      slug: PropTypes.string.isRequired,
      tech: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  }
  static defaultProps = {
    company: {},
    project: {},
  }
  
  state = {
    hover: false,
    loaded: false,
  }
  handleHover = () => this.setState({ hover: true })
  handleUnHover = () => this.setState({ hover: false })
  
  handleImageLoad = () => this.setState({ loaded: true })
  
  get hero() {
    const { project } = this.props;
    if (!project.images || !project.images.length) return null;
    const hero = project.images[0];
    return (
      <div className={ styles.imgWrap }>
        <Image
          src={ hero }
          className={ styles.hero }
          alt={ 'hero' }
          onLoad={ this.handleImageLoad } />
      </div>
    );
  }
  
  get title() {
    const { company, project } = this.props;
    
    if (!project.name || !company.name) {
      if (!company.name) return project.name;
      return company.name;
    }
    return `${ company.name } - ${ project.name }`;
  }
  
  render() {
    const { className, project } = this.props;
    const { loaded } = this.state;
    const { slug } = project;
    const classes = classnames(className, styles.projectPreview, {
      [styles.loading]: !loaded,
    });
    
    return (
      <Link
        className={ classes }
        to={ `/portfolio/${ slug }` }
        onMouseOver={ this.handleHover }
        onMouseOut={ this.handleUnHover }
      >
        <div className={ styles.title }>{ this.title }</div>
        <div className={ styles.heroWrap }>
          <div className={ styles.spinner }><div className={ styles.spinnerIcon } /></div>
          { this.hero }
          <div className={ styles.overlay } />
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectPreview/index.jsx